<app-kontable
        #table
        title="{{ 'common.serviceType' | translate}}"
        [columns]="['id', 'name', 'description']"
        [titles]="['ID', 'serviceList.name', 'serviceList.description']"
        [source]="srvServiceType.serviceTypes"
        [paginationType]="clientPagination"
        [showGlobalFilter]="false"
        [showDetailsButton]="false"
        [showRecoverButton]="false"
        [showAddButton]="true"
        [(fireNewDataAvailable)]="newDataAvailable"
        (onAdd)="showAddEditDialog($event)"
        (onEdit)="showAddEditDialog($event)"
        (onRemove)="delete($event)"
>
</app-kontable>

<p-dialog
        *ngIf="showAddOrEdit"
        [(visible)]="showAddOrEdit"
        header="{{modalTitle}}"
        [modal]="true"
        [minWidth]="500"
        [draggable]="false"
        [resizable]="false">
    <app-service-type-form
      [dialogBoxServiceType]="srvServiceType.serviceTypeEditing"
      (endSaveOrUpdate)="closeDialog($event)"
      (serviceTypeAdded)="serviceTypeAdded($event)"
      (serviceTypeUpdated)="serviceTypeUpdated($event)">
    </app-service-type-form>
</p-dialog>




// WEBPACK FOOTER //
// ./src/app/views/administration/service-type/service-type.component.html